var map = {
	"./en": [
		"yZm8",
		7
	],
	"./en.json": [
		"yZm8",
		7
	],
	"./es": [
		"vnEV",
		6
	],
	"./es.json": [
		"vnEV",
		6
	],
	"./fr": [
		"kV3b",
		5
	],
	"./fr.json": [
		"kV3b",
		5
	],
	"./zh-CN": [
		"VRxq",
		4
	],
	"./zh-CN.json": [
		"VRxq",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Trjk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*$
// module id = Trjk
// module chunks = 12